import { supabase } from "@/lib/supabaseClient";
import { toast } from "sonner";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "";
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "";

export async function downloadPdf(simulacaoId: string): Promise<boolean> {
  const { data: session } = await supabase.auth.getSession();
  if (!session.session) {
    toast.error("Faça login para baixar o PDF");
    return false;
  }

  const toastId = toast.loading("Gerando PDF...");

  try {
    const res = await fetch(`${SUPABASE_URL}/functions/v1/generate-report`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.session.access_token}`,
        apikey: SUPABASE_ANON_KEY,
      },
      body: JSON.stringify({ simulacao_id: simulacaoId, format: "pdf" }),
    });

    const data = await res.json();

    if (!res.ok || !data.pdf) {
      toast.dismiss(toastId);
      toast.error(data.error || "Erro ao gerar PDF");
      return false;
    }

    // Decode base64 and trigger download
    const byteChars = atob(data.pdf);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = data.filename || "relatorio-autocarbid.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    toast.dismiss(toastId);
    toast.success("PDF baixado com sucesso!");
    return true;
  } catch {
    toast.dismiss(toastId);
    toast.error("Erro ao gerar PDF");
    return false;
  }
}
